<template>
  <div id="login">
    <div class="box hide-scrollbars">
      <div class="info">
        <img class="logo" :src="'../../../img/logo_new_black.png'">
        <template v-if="inTime">
          <div class="description">{{$t('login.reset_password')}}</div>
          <div class="form">
            <template v-if="changedSuccess">
              <div class="success">{{$t('login.reset_success')}}</div>
              <button type="button" @click="redirect()">{{ $t('init') }}</button>
            </template>
            <template v-else>
              <div v-if="errorPassword" class="message error">{{$t('errors.different_passwords')}}</div>
              <div v-if="errorChanged" class="message error">{{$t('errors.api')}}</div>
              <input type="password" name="password1" v-model.trim="password1" :placeholder="$t('login.new_password')">
              <input type="password" name="password2" v-model.trim="password2" :placeholder="$t('login.repeat_password')">
              <button type="button" @click="changePassword()">{{ $t('reset') }}</button>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="message error">{{$t('login.link_expired')}}</div>
        </template>
      </div>
    </div>

    <div class="tech-partner">
      <a href="https://intowingroup.com/" target="_blank" class="logo">| {{ $t( 'login.tech_partner' ) }}</a>
    </div>
  </div>
</template>

<script>
/* global moment, sha256, isEmpty */
import { Api } from '@/core/api.js'
import i18n from '@/i18n'

const api = new Api()

export default {
  name: 'ChangePassword',
  components: {

  },
  data () {
    return {
      password1: '',
      password2: '',
      id: '',
      limit: '',
      lang: '',
      inTime: false,
      errorPassword: false,
      changedSuccess: false,
      errorChanged: false
    }
  },
  created () {
    // save params
    this.id = this.$route.params.id
    this.limit = this.$route.params.limit
    this.lang = this.$route.params.lang

    // validate language
    if (!['ca', 'es', 'en'].includes(this.lang)) {
      this.lang = 'ca'
    }

    var self = this

    // load language
    i18n.loadLanguageAsync(this.lang).then(function () {
      // link in time
      if (moment().valueOf() <= moment(self.limit * 1000).valueOf()) {
        self.inTime = true
      }
    })
  },
  methods: {

    changePassword () {
      // remove all alerts
      this.errorPassword = false
      this.changedSuccess = false
      this.errorChanged = false

      // check if 2 password aren't empty
      if (!isEmpty(this.password1) && !isEmpty(this.password2)) {
        let password1 = sha256(this.password1)
        let password2 = sha256(this.password2)

        // same password => update
        if (password1 === password2) {
          var self = this

          // update password
          api.post('reset', { id: this.id, password: password1 }).then(function (response) {
            if (response.status) {
              self.changedSuccess = true
            } else {
              self.errorChanged = true
            }
          })
        } else {
          // passwords are diferent, show error
          this.errorPassword = true
        }
      }
    },

    redirect () {
      this.$router.push({ 'name': 'home' }).catch()
    }

  }
}
</script>

<style lang="scss" scoped>

  #container {
    padding: 0 !important;
  }

  #login {
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 25px;
    background: linear-gradient(0deg, #ddd, #FFF);
    color: $secondary-color;
    overflow: auto;

    .box {
        max-width: 275px;
        width: 100%;
        height: auto;
        max-height: calc(100% - 40px);
        margin: 0 auto;
        overflow: auto;
        text-align: center;

        .message.error {
            background-color: #f73f2061;
            margin: 10px 0;
            border: 2px solid #e61515;
            border-radius: 5px;
            padding: 10px;
            color: #FFF;
            font-weight: bold;
            text-align: center;
        }

        .info {
          text-align: center;

          .logo {
            display: inline-block;
            width: 100%;
            padding: 15px;
          }

          .description {
            width: 100%;
            display: block;
            color: $main-color;
            font-size: 16px;
            text-align: center;
          }
        }
        .form  {
          margin-top: 50px;
        }

        input {
          width: 100%;
          padding: 15px;
          margin-bottom: 5px;
          border: 1px solid #444;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: $main-color;
          display: block;

          &::placeholder{
            color: $main-color;
          }
        }

        button {
          width: calc(100%);
          padding: 12px;
          outline: none;
          border: none;
          cursor: pointer;
          font-size: 12pt;
          border-radius: 3px;
          text-transform: uppercase;
          transition: all 0.5s;
          background-color: #000;
          color: $secondary-color;
          margin-top: 12px;
          font-weight: bold;

          &.secondary {
            background: none;
            text-transform: initial;
            color: #999;
            font-weight: lighter;

            &:hover {
              text-decoration: underline;
            }
          }

          // &:hover {
          //   // background-color: $main-color;
          //   // color: #fff;
          // }
        }

        button + .mlanguage {
          width: calc(100% - 50px);
        }

        button + .mlanguage, .mlanguage {
          display: inline-block;
          margin-top: 12px;
          height: 40px;
        }
        .mlanguage {
          float: none;
        }

        .remember {
            font-size: 10pt;
            margin-top: 20px;
            color: $secondary-color;
            cursor: pointer;
            display: block;
            text-decoration: none;
            text-align: center;
            color: #999;
            text-decoration: underline;

            &:hover {
                text-decoration: underline;
            }
        }

        .success {
          border: 2px solid #087908;
          border-radius: 5px;
          background-color: #a0f8b6;
          color: #000;
          padding: 10px;
          font-size: 16px;
          text-align: center;
        }

    }

    .tech-partner {
      @include display-flex();
      @include align-items(center);
      @include justify-content(center);
      position: fixed;
      bottom: 10px;
      left: 0;
      width: 100%;
      text-align: center;
      height: 50px;

      .logo {
        @include background( $image: img('logo_intowin_black.svg'), $size: 100px, $position: left center );
        display: inline-block;
        color: rgb(97, 85, 85);
        padding-left: 105px;
      }
    }
  }

  @include media("<=desktop") {
    #login {
      overflow: hidden;

      .box .info .logo {
        height: 50px;
        padding: 6px;
        width: auto;
      }
      .box .form  {
        margin-top: 24px;
      }

    }

  }

</style>
